// extracted by mini-css-extract-plugin
module.exports = {"tab":"JournalIndicator_tab__Gsnsq","tabPlaceholder":"JournalIndicator_tabPlaceholder__2AsyB","section":"JournalIndicator_section__3pFrs"};